import type { BaseQueryFn, RetryOptions } from '@reduxjs/toolkit/query';
import { retry } from '@reduxjs/toolkit/query/react';

const rtkQueryRetryOptions: RetryOptions = {
    maxRetries: 2,
};

/**
 * Wraps the baseQuery with retry logic for rtk-query.
 * @example
 * // maxRetries: 5 is the default
 * const staggeredBaseQuery = retry(fetchBaseQuery({ baseUrl: '/' }), {
 *   maxRetries: 2,
 * })
 * export const api = createApi({
 *   baseQuery: staggeredBaseQuery,
 *   // ...
 * })
 */
export const rtkAppRetry = <BaseQuery extends BaseQueryFn>(
    baseQuery: BaseQuery,
    options: RetryOptions = rtkQueryRetryOptions
) => retry(baseQuery, options);
